export { default as MainTemplate } from './MainTemplate';
export {
  mainTemplateMetaTagAdapter,
  mainTemplateNavigationAdapter,
  mainTemplateStylesAdapter,
  homepageMetadataAdapter,
} from './adapters';
